import { Direction } from "@common/constans";
import { FlightPoint, IFlightSegment } from "@common/models";
import Icon from "@components/general/Icon";
import { Culture } from "@core/index";
import { comma, getAirport, minToMinHour } from "@utilize/Format";
import { FC } from "react";
import ContentLoader from "react-content-loader";

interface IFlightRouteProps {
    flightSegment: IFlightSegment;
}

const FlightRoute: FC<IFlightRouteProps> = ({ flightSegment }) => {
    const dateTime = Culture.getDateTimeInstance();
    dateTime.setTime(flightSegment.departureDateTime || 0);
    const depDate = dateTime.format("H:i");
    dateTime.setTime(flightSegment.arrivalDateTime || 0);
    const arrDate = dateTime.format("H:i");

    const terminal = {
        origin: new FlightPoint(flightSegment.origin || {}).getDefaultTerminal(Direction.Departure, flightSegment.destination?.code || "")?.displayText,
        destination: new FlightPoint(flightSegment.destination || {}).getDefaultTerminal(Direction.Arrival, flightSegment.origin?.code || "")?.displayText
    }

    return (
        <div className="checkin-flight-route">
            <div className="flight-route-section">
                {
                    flightSegment.origin ?
                        <>
                            <div className="flight-route-city trim">{getAirport(flightSegment.origin?.code).cityName}<small>&nbsp;({flightSegment.origin?.code})</small></div>
                            <div className="flight-route-time">{depDate}</div>
                            <div className="flight-route-airport trim">{`${getAirport(flightSegment.origin?.code).airportName}${terminal.origin ? (comma() + " " + terminal.origin) : ''}`}</div>
                        </>
                        :
                        <>
                            <ContentLoader width="70%" height="30px">
                                <rect x="0" y="0" rx="10px" ry="10px" width="100%" height="100%" />
                            </ContentLoader>
                            <ContentLoader width="40%" height="20px">
                                <rect x="0" y="0" rx="10px" ry="10px" width="100%" height="100%" />
                            </ContentLoader>
                            <ContentLoader width="70%" height="20px">
                                <rect x="0" y="0" rx="10px" ry="10px" width="100%" height="100%" />
                            </ContentLoader>
                        </>
                }
            </div>
            <div className="text-center">
                <Icon name="icon-airplane" />
                <div className="flight-route-duration">
                    {
                        flightSegment.journeyDuration ? minToMinHour(flightSegment.journeyDuration || 0) :
                            <ContentLoader width="20%" height="10px">
                                <rect x="0" y="0" rx="5px" ry="5px" width="100%" height="100%" />
                            </ContentLoader>
                    }
                </div>
            </div>
            <div className="flight-route-section">
                {
                    flightSegment.destination ?
                        <>
                            <div className="flight-route-city trim">{getAirport(flightSegment.destination?.code).cityName}<small>&nbsp;({flightSegment.destination?.code})</small></div>
                            <div className="flight-route-time">{arrDate}</div>
                            <div className="flight-route-airport trim">{`${getAirport(flightSegment.destination?.code).airportName}${terminal.destination ? (comma() + " " + terminal.destination) : ''}`}</div>
                        </>
                        :
                        <>
                            <ContentLoader width="70%" height="30px">
                                <rect x="0" y="0" rx="10px" ry="10px" width="100%" height="100%" />
                            </ContentLoader>
                            <ContentLoader width="40%" height="20px">
                                <rect x="0" y="0" rx="10px" ry="10px" width="100%" height="100%" />
                            </ContentLoader>
                            <ContentLoader width="70%" height="20px">
                                <rect x="0" y="0" rx="10px" ry="10px" width="100%" height="100%" />
                            </ContentLoader>
                        </>
                }
            </div>
        </div>
    )
}

export default FlightRoute;